module.exports = __webpack_public_path__ + "img/icon_02.c6fab935.png";